(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gch-nav"] && !Shopify.designMode) return;
  try {
    
  /**
   * Keeps --gch-rail wide enough for the rail's actual content.
   *
   * The rail is position:fixed, so page content reserves space for it via
   * padding rather than layout. assets/gch-theme.css ships the prototype's
   * measured default (260px), but the rail's real width depends on the menu
   * the merchant sets — a long label like "Never Slept Better" is wider than
   * the logo and would run under the content. Measuring and taking the larger
   * of the two widens the gutter instead.
   *
   * Mirrors the approach Horizon uses for --header-height in layout/theme.liquid.
   */
  (() => {
    const DEFAULT_RAIL = 260;

    const measureRail = () => {
      const rail = document.querySelector('.gch-rail');
      if (!rail) return;

      // Skip while the rail is display:none (mobile) — offsetParent is null and
      // every child rect collapses to 0, which would clamp to the default anyway.
      if (!rail.offsetParent && getComputedStyle(rail).position !== 'fixed') return;

      const railLeft = rail.getBoundingClientRect().left;
      const children = rail.querySelectorAll('.gch-nav__link, .gch-nav__logo, .gch-nav__action');
      let widest = 0;

      for (const child of children) {
        widest = Math.max(widest, child.getBoundingClientRect().right - railLeft);
      }

      if (!widest) return;

      const gutter = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--gch-rail-gutter')) || 58;
      const needed = Math.ceil(Math.max(DEFAULT_RAIL, widest + gutter));

      document.documentElement.style.setProperty('--gch-rail', `${needed}px`);
    };

    // Fonts change the measurement, so re-measure once they land.
    measureRail();
    if (document.fonts?.ready) document.fonts.ready.then(measureRail);
    window.addEventListener('resize', measureRail);
    document.addEventListener('shopify:section:load', measureRail);
  })();

  /**
   * Mobile nav drawer.
   *
   * Uses a native <dialog> via showModal() so focus trapping, Esc-to-close and
   * the inert backdrop come from the platform. Listeners are delegated from
   * document so the drawer keeps working after a section re-render in the
   * theme editor, where the markup is replaced but document persists.
   */
  (() => {
    const DRAWER_ID = 'gch-drawer';

    const drawer = () => document.getElementById(DRAWER_ID);

    const setToggleState = (expanded) => {
      document.querySelectorAll('[data-gch-drawer-open]').forEach((el) => {
        el.setAttribute('aria-expanded', String(expanded));
      });
    };

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const dialog = drawer();
      if (!dialog) return;

      if (target.closest('[data-gch-drawer-open]')) {
        event.preventDefault();
        if (typeof dialog.showModal === 'function' && !dialog.open) dialog.showModal();
        setToggleState(true);
        return;
      }

      if (target.closest('[data-gch-drawer-close]')) {
        event.preventDefault();
        dialog.close();
        return;
      }

      // A nav link inside the drawer navigates; close so the drawer isn't
      // still open if the browser restores this page from cache.
      if (dialog.open && target.closest('.gch-drawer .gch-nav__link')) {
        dialog.close();
      }
    });

    // `close` does not bubble from <dialog>, so this delegated listener has to
    // run in the capture phase to see it at all. Without capture the toggle's
    // aria-expanded stays "true" after the drawer closes.
    document.addEventListener(
      'close',
      (event) => {
        if (event.target instanceof Element && event.target.id === DRAWER_ID) {
          setToggleState(false);
        }
      },
      { capture: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gch-tour"] && !Shopify.designMode) return;
  try {
    
  /**
   * Tour artist tabs.
   *
   * Delegated from document so the tabs keep working after a section
   * re-render in the theme editor. Follows the ARIA tabs pattern: roving
   * tabindex, arrow-key navigation, and `hidden` on the inactive panels.
   *
   * Panels are hidden rather than removed. The Bandsintown embed replaces its
   * initializer on load, so tearing a panel out of the DOM would destroy a
   * widget that cannot be re-initialised without re-running its script.
   */
  (() => {
    const tabsIn = (root) => [...root.querySelectorAll('.gch-tour__tab')];

    const select = (tab) => {
      const root = tab.closest('.gch-tour');
      if (!root) return;

      for (const other of tabsIn(root)) {
        const selected = other === tab;
        other.setAttribute('aria-selected', String(selected));
        other.tabIndex = selected ? 0 : -1;

        const panel = document.getElementById(other.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      }
    };

    document.addEventListener('click', (event) => {
      const tab = event.target instanceof Element && event.target.closest('.gch-tour__tab');
      if (tab) select(tab);
    });

    document.addEventListener('keydown', (event) => {
      const tab = event.target instanceof Element && event.target.closest('.gch-tour__tab');
      if (!tab) return;

      const keys = { ArrowLeft: -1, ArrowRight: 1, Home: 'first', End: 'last' };
      const move = keys[event.key];
      if (move === undefined) return;

      event.preventDefault();
      const all = tabsIn(tab.closest('.gch-tour'));
      let next;

      if (move === 'first') next = all[0];
      else if (move === 'last') next = all[all.length - 1];
      else next = all[(all.indexOf(tab) + move + all.length) % all.length];

      next.focus();
      select(next);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
